import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m16.847 12.471 2.645-2.654a3.754 3.754 0 0 0-2.685-6.316 3.76 3.76 0 0 0-2.63 1.007l-2.645 2.655M12.41 16.904l-2.658 2.654a3.762 3.762 0 0 1-6.25-2.705 3.75 3.75 0 0 1 .947-2.604l2.658-2.654"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "m4.93 4.93 14.142 14.142"
    }, null, -1)
  ]))]))
}
export default { render: render }